import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-brand-darker text-gray-400 py-16 border-t border-white/5">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold text-xl mb-4 flex items-center gap-2">
              <SafeIcon name="Book" className="text-brand-yellow" /> Translation Table
            </h4>
            <p className="text-sm leading-relaxed max-w-sm mb-6">
              Helping thousands of people understand what their partner actually means — so they can stop fighting and start connecting.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-brand-yellow transition-colors" aria-label="Instagram">
                <SafeIcon name="Instagram" className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-yellow transition-colors" aria-label="TikTok">
                <SafeIcon name="Video" className="w-5 h-5" />
              </a>
            </div>
            <p className="text-sm mt-2">@translationtable</p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">What Happens Next</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><SafeIcon name="ArrowRight" className="w-3 h-3 text-brand-yellow" /> Enter your email</li>
              <li className="flex items-center gap-2"><SafeIcon name="ArrowRight" className="w-3 h-3 text-brand-yellow" /> Check your inbox</li>
              <li className="flex items-center gap-2"><SafeIcon name="ArrowRight" className="w-3 h-3 text-brand-yellow" /> Download 14-page guide</li>
              <li className="flex items-center gap-2"><SafeIcon name="ArrowRight" className="w-3 h-3 text-brand-yellow" /> Use one translation tonight</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm">Contact</h4>
            <p className="text-sm mb-2">Questions?</p>
            <a href="mailto:hello@translationtable.com" className="text-brand-yellow hover:underline text-sm">
              hello@translationtable.com
            </a>
          </div>

        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>© {new Date().getFullYear()} Translation Table. All rights reserved.</p>
          <div className="flex gap-4">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;